import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// import resourcesToBackend from "i18next-resources-to-backend";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import * as R from "ramda";

// import translationEN from "./locales/en.json";
// import translationFR from "./locales/fr.json";
// import translationES from "./locales/es.json";
// import translationDE from "./locales/de.json";
// import translationIT from "./locales/it.json";

// the translations
// Adding german translation
// const resources = {
// en: {
//   translations: translationEN,
// },
// fr: {
//   translations: translationFR,
// },
// es: {
//   translations: translationES,
// },
// de: {
//   translations: translationDE,
// },
// it: {
//   translations: translationIT,
// },
// };

const spectreLanguageDetector = {
  name: "spectre_language",

  lookup: function lookup() {
    let _language;
    let _country;
    if (typeof window !== "undefined") {
      _language = window.localStorage.getItem("spectre_language");
      _country = window.localStorage.getItem("spectre_country");

      if (!_language) {
        _language = navigator.language.split("-")[0];
      }

      if (!R.contains(_language, ["en", "fr", "es", "de", "it", "ja", "ko", "pt", "zh"])) {
        _language = "en";
        window.localStorage.setItem("spectre_language", _language);
      }

      if (!_country) {
        _country =
          navigator.language.split("-").length > 1
            ? navigator.language.split("-")[1]
            : "CA";
      }

      window.localStorage.setItem("spectre_country", _country);
    }

    return _language;
  },
  cacheUserLanguage: function cacheUserLanguage(lng) {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("spectre_language", lng);
    }
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(spectreLanguageDetector);

const languageDetectionOptions = {
  // order and from where user language should be detected
  order: ["spectre_language"],

  // cache user language on
  caches: ["spectre_language"],
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  // .use(
  //   resourcesToBackend((language, namespace) => {
  //     debugger;
  //     console.log("language", language);
  //     return import(`./locales/${language}.json`);
  //   })
  // )
  .use(Backend)
  .init({
    // resources,
    detection: languageDetectionOptions,
    fallbackLng: "en",

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    react: {
      useSuspense: false,
    },

    backend: {
      // for all available options read the backend's repository readme file
      //
      // Stamped with the release. Everything else the app ships has a content
      // hash in its file name, so a deploy is a new URL and arrives; the
      // translation files are the one exception -- "/locales/en.json" is the
      // same address for ever, and a browser that already has a copy keeps
      // it. A key added in this release then has no translation to find, and
      // i18next falls back to printing the key itself: the scan screen went
      // out reading "specsheetScan.credits.left" on the day the paywall
      // shipped. The version turns each release's file into its own address.
      loadPath: `/locales/{{lng}}.json?v=${process.env.REACT_APP_VERSION || "dev"}`,
    },
  });

export default i18n;
